import { combineReducers } from '@reduxjs/toolkit';

import user from './user/reducer';

export default combineReducers({
  user,
});
